<template>
  <div>
    <div>
      <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="false">
        <div @keyup.enter.stop="save()">
          <el-form-item label="选择专业" prop="categoryIds">
            <el-select v-model="categoryIds" multiple placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="item in categoryList"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="评语内容" prop="remarkContent" :rules="[$validate.string(100)]">
            <el-input type="textarea" v-model="form.remarkContent" :maxlength="100" show-word-limit
                      placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {},
      categoryList: [],
      categoryIds: [],
      queryParam: { categoryLevel: 2 }
    }
  },
  async created () {
    await this.initForm()
    this.categoryList = await this.$HTTP.ApiCategory.getGradeTreeData(this.queryParam)
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        let info = JSON.parse(JSON.stringify(this.row))
        this.form = info
        if (this.form.categoryIds) {
          this.categoryIds = this.form.categoryIds.split(',')
        }
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        if (this.form.remarkId) {
          this.form.categoryIds = this.categoryIds
          await this.$HTTP.GradeRemark.edit(this.form)
        } else {
          this.form.isPublic = 1
          this.form.categoryIds = this.categoryIds
          await this.$HTTP.GradeRemark.add(this.form)
        }
        this.$message({ type: 'success', message: '操作成功' })
        this.$emit('close', true)
      }
    }
  }
}
</script>
<style>
  .el-input__count {
    top: 28px;
  }
</style>
